import { stringify } from 'qs';

/**
 * Given a filters object, returns a URL that reflects the selected filters.
 * Intended to be used in a React Router Link context.
 * @param {object} filters - Filters object to encode.
 * @returns {string} The query string-based URL for use in the Link component.
 */
const getFilterUrl = (filters) => `?${stringify(filters)}`;

export default getFilterUrl;
